{
  "addressLoadFailed": "获取地址失败",
  "usdtTrc20": "USDT（TRC20）",
  "usdtTrc20Network": "USDT TRC-20",
  "rateLoadFailed": "获取汇率失败",
  "copied": "已复制",
  "conversionDescription": "USDT转入后，系统将依平台当前USDT兑{{token}}汇率结售为{{token}}后，存放到您的{{token}}钱包资产中。",
  "rate": "汇率",
  "rateFromUsdt": "1 USDT ≈ {{amount}} {{token}}",
  "title": "闪兑",
  "hintTitle": "温馨提示",
  "addressOnlySupports": "本地址与二维码仅支持",
  "addressOnlySupportsSuffix": "的类型，类型错误可能无法找回且网站不予赔付。请确认您所需的转币类型。",
  "confirmationHint": "一般提币流程需经过多个区块链确认，本地址时时刷新请以到账确认为主。"
}
